import { useMemo, useState, useEffect, useCallback } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as PanelPermissionsDucks from 'granite-admin/common/ducks/panelPermissions';
import * as HelpTextDucks from 'granite-admin/common/ducks/helptext';
import * as MasterConfigDucks from 'granite-admin/common/ducks/masterConfig';
import helpTextAPI from 'granite-admin/common/gateways/help-text-api';
import organisationAPI from 'granite-admin/organisations/gateways/organisation-api';
import commonApi from 'granite-admin/common/gateways/common-api.js';
import useUtility from 'granite-admin/utils/useUtility';
function useRouteChange(props) {
  const {
    grandEmitter
  } = useUtility();
  const {
    permissions
  } = props || {
    permissions: []
  };
  const {
    fields,
    entity_name,
    shouldFetchHelpTexts = true,
    shouldFetchPermissions = true,
    clearDataRouteChange = true
  } = props || {};
  // both initially true to avoid Component remount on changes in "isLoading"
  const [isPermissionLoading, setIsPermissionLoading] = useState(shouldFetchPermissions);
  const [isConfigLoading, setIsConfigLoading] = useState(true); // separate for configs to avoid race condition
  const [hasAccess, setHasAccess] = useState(true);
  // const [pagePermissions,setPagePermissions] = useState([])

  const {
    path: url,
    params
  } = useRouteMatch();
  const path = useMemo(() => {
    let theUrl = url;
    Object.keys(params).forEach(key => {
      if (key.includes('sr_')) theUrl = theUrl?.replace(`:${key}`, params[key]);
    });
    return theUrl;
  }, [url, params]);
  const dispatch = useDispatch();
  const userProfile = useSelector(({
    accounts
  }) => accounts.user.profile);
  const helptexts = useSelector(({
    common
  }) => common.helptext.helpTexts);
  const panelPermissions = useSelector(({
    common
  }) => common.panelPermissions.panelPermissions);
  const getMasterConfig = useCallback(async () => {
    //send the field options and type to updateMaster ducks
    try {
      setIsConfigLoading(true);
      // let hasDocument;
      // if(pagePermissions)
      // {
      //   hasDocument = pagePermissions?.filter(e=>e.type === "documents")
      //     if(hasDocument)
      // fields =  fields?.length > 0 ? [...fields, 'docType', 'docSubType'] : ['docType', 'docSubType'] 
      // } 

      // setTimeout(() => {
      //   console.log("fields in useroute change is ",fields,pagePermissions,path,hasDocument)
      //   console.log({hasDocument})
      // }, 6000);
      const res = await commonApi.getMasterConfigurations(fields, entity_name);
      dispatch(MasterConfigDucks.updateMasterConfiguration(res.results));
      setIsConfigLoading(false);
    } catch (error) {
      console.log('error', error);
      setIsConfigLoading(false);
    }
  }, [fields, dispatch, entity_name]);
  const fetchPermissions = useCallback(() => {
    if (!panelPermissions[path]) {
      setIsPermissionLoading(true);
      organisationAPI.getPanelPermission(path).then(resp => {
        // setTimeout(() => {
        //   console.log("panel eprm,ission resp is ============ ",resp,path)
        // }, 5000);
        if (resp.length) {
          const permissions = {};
          // setPagePermissions(resp)
          permissions[path] = resp.filter(i => {
            if (i?.extra_data?.noPermission) return i;
            return i?.permission?.every(val => userProfile.permissions.includes(val));
          });
          dispatch(PanelPermissionsDucks.updatePanelPermissions(permissions));
        }
        setIsPermissionLoading(false);
      }).catch(err => {
        console.log(err);
        setIsPermissionLoading(false);
      });
    } else if (permissions?.length && panelPermissions[path]) {
      const allPermissions = panelPermissions[path]?.map(i => i.type);
      if (!permissions?.every(val => allPermissions.includes(val))) setHasAccess(false);
      setIsPermissionLoading(false);
    } else {
      setIsPermissionLoading(false);
    }
  }, [path, dispatch]);
  const fetchHelpTexts = useCallback(() => {
    if (helptexts[path]) return true;
    const params = {
      context_id: path
    };
    helpTextAPI.getHelpText(params).then(res => {
      const newHelpText = {};
      if (res.length) {
        res.forEach(function (item) {
          if (!newHelpText[item.contextId]) {
            newHelpText[item.contextId] = {
              [item.controlId]: {
                data: item.helpText,
                type: 'text',
                ...item
              }
            };
          } else {
            newHelpText[item.contextId][item.controlId] = {
              data: item.helpText,
              type: 'text',
              ...item
            };
          }
        });
      } else {
        newHelpText[path] = {};
      }
      // TODO: The redux function should be smart enough to update the new data in its old data.
      dispatch(HelpTextDucks.updateHelpText(newHelpText));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, helptexts, path]);
  useEffect(() => {
    if (fields && fields.length) {
      getMasterConfig();
    } else {
      if (clearDataRouteChange) dispatch(MasterConfigDucks.updateMasterConfiguration([]));
      setIsConfigLoading(false);
    }
  }, [fields, path, getMasterConfig, clearDataRouteChange, dispatch]);

  //   const fetchConfig = useCallback(async ()=>{
  //   try {
  //     setIsConfigLoading(true);
  //     let hasDocument;
  //     if(pagePermissions)
  //     {
  //       hasDocument = pagePermissions?.filter(e=>e.type === "documents")
  //         if(hasDocument)
  //     fields =  fields?.length > 0 ? [...fields, 'docType', 'docSubType'] : ['docType', 'docSubType'] 
  //     } 

  //     setTimeout(() => {
  //       console.log("fields in useroute change is ",fields,pagePermissions,path,hasDocument)
  //       console.log({hasDocument})
  //     }, 8000);
  //     const res = await commonApi.getMasterConfigurations(fields, entity_name);
  //     dispatch(MasterConfigDucks.updateMasterConfiguration(res.results));
  //     setIsConfigLoading(false);
  //   } catch (error) {
  //     console.log('error', error);
  //     setIsConfigLoading(false);
  //   }
  // },[fields, dispatch, entity_name,pagePermissions])
  // useEffect(()=>{
  //   setTimeout(() => {
  //     console.log("useffect called ", fields)
  //   }, 10000);
  //  fetchConfig()
  // },[fetchConfig])

  useEffect(() => {
    grandEmitter.emit('ADD_SUBROUTE', path);
    if (shouldFetchHelpTexts) fetchHelpTexts();

    // if (!panelPermissions[path]) {
    if (shouldFetchPermissions) fetchPermissions();
    // } else if (permissions?.length && panelPermissions[path]) {
    //   const allPermissions = panelPermissions[path]?.map(i => i.type);
    //   if (!permissions?.every(val => allPermissions.includes(val))) setHasAccess(false);
    // }
  }, [path, shouldFetchHelpTexts, shouldFetchPermissions]);

  // waiting for both API response to avoid race condition
  return {
    isPermissionLoading: isPermissionLoading || isConfigLoading,
    hasAccess
  };
}
export default useRouteChange;